// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import styles from './characterSymbol.module.css';

function CharacterSymbolComponent(props) {
    const displaySymbol = props.char.symbol === " " ? "␠" : props.char.symbol;
    const displayRomaji = props.char.romaji === "space" ? "space" : props.char.romaji;
    const className = props.isHighlighted ? `${styles.pile} ${styles.highlight}` : styles.pile;

    return (
        <button className={className} onClick={() => props.handleChange(props.char.symbol)}>
            <span className={styles.symbol}>{displaySymbol}</span>
            <span className={styles.romaji}>{displayRomaji}</span>
        </button>
    );
}

export default CharacterSymbolComponent;